import { ValidatedPdbResidue } from '../types';

export interface ViewerResidueSelection {
  chain: string;
  resi: number;
  icode?: string;
}

export interface MainModelResidueSelection extends ViewerResidueSelection {
  model: 0;
}

export const residuesForPdb = (
  residues: ValidatedPdbResidue[] | undefined,
  pdbId: string
): ValidatedPdbResidue[] => {
  const normalizedPdbId = pdbId.trim().toUpperCase();
  if (!normalizedPdbId || !Array.isArray(residues)) return [];

  return residues.filter(
    residue => residue.pdb_id?.trim().toUpperCase() === normalizedPdbId
  );
};

export const toViewerSelection = (
  residue: ValidatedPdbResidue
): ViewerResidueSelection => ({
  chain: residue.chain_id,
  resi: residue.residue_number,
  ...(residue.insertion_code ? { icode: residue.insertion_code } : {}),
});

export const toMainModelSelection = (
  residue: ValidatedPdbResidue
): MainModelResidueSelection => ({
  ...toViewerSelection(residue),
  model: 0,
});

export const residueDisplayLabel = (residue: ValidatedPdbResidue): string =>
  `${residue.residue_one_letter}${residue.residue_number}${residue.insertion_code || ''}`;
